import { ref } from "vue";
import { login } from "@voghion/native-api";

const clientInfo = ref(null);
const currencyMap = new Map([
  ["EUR", "€"],
  ["NZD", "$"],
  ["AUD", "$"],
  ["CAD", "C$"],
  ["USD", "$"],
  ["HRK", "kn"],
  ["CZK", "Kč"],
  ["DKK", "kr"],
  ["NOK", "kr"],
  ["SEK", "kr"],
  ["ISK", "kr"],
  ["HUF", "Ft"],
  ["PLN", "zł"],
  ["CHF", "Fr"],
  ["TRY", "₺"],
  ["GBP", "£"],
  ["BGN", "лв"],
  ["RSD", "Дин"],
  ["RUB", "₽"],
  ["PHP", "₱"],
  ["RON", "RON"],
]);

/**
 * 设置
 * @returns
 */
export const useSetting = () => {
  /**
   * 获取 clientInfo
   * @returns {Object}
   */
  const getClientInfo = () => {
    return clientInfo.value || {};
  };
  /**
   * 是否已登录
   * @returns
   */
  const isLogin = () => {
    const clientInfoVO = getClientInfo();
    return !!clientInfoVO.userToken;
  };
  return {
    /**
     * 更新 clientInfo
     * @param value
     */
    updateClientInfo(value) {
      clientInfo.value = value;
    },
    getClientInfo,
    isLogin,
    /**
     * 格式化价格
     * @param price
     * @returns
     */
    formatPrice(price) {
      price += "";
      let priceStr = parseFloat(price);
      if (price.includes(".")) {
        priceStr.toFixed(2);
      }
      const currency = clientInfo.value?.currency || "EUR";
      const symbol = currencyMap.get(currency) || currencyMap.get("EUR");
      if (symbol === "€") {
        return `${priceStr} €`;
      }
      return `${symbol} ${priceStr}`;
    },
  };
};
